import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/lib/SmoothScroll";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import Admin from "@/pages/Admin";
import ScrollToTop from "@/lib/ScrollToTop";

function ChromeSwitch() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <FloatingWhatsApp />;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF9F6] text-[#1A1A1A]">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/admin" element={<Admin />} />
            {/* legacy redirects */}
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/services" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <ChromeSwitch />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#FAF9F6",
            border: "1px solid #8C7A6B",
            borderRadius: "0",
            fontFamily: "Cabinet Grotesk, sans-serif",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
